import { __rest } from "tslib";
import { observer, useField } from '@formily/react';
import { isArr, isFn, isValid } from '@formily/shared';
import { Tag } from 'antd-mobile';
import cls from 'classnames';
import React, { createContext, useContext } from 'react';
import { formatMomentValue, usePrefixCls } from '../__builtins__';
const PlaceholderContext = createContext('N/A');
const Placeholder = PlaceholderContext.Provider;
const usePlaceholder = (value) => {
    const placeholder = useContext(PlaceholderContext) || 'N/A';
    return isValid(value) && value !== '' ? value : placeholder;
};
const Input = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const prefixCls = usePrefixCls('form-text', props);
    return (React.createElement("div", { className: cls(prefixCls, className) }, usePlaceholder(props.value)));
};
const Text = (props) => {
    const prefixCls = usePrefixCls('form-text', props);
    return (React.createElement("div", { className: cls(prefixCls, props.className), style: props.style }, usePlaceholder(props.value)));
};
const Selector = observer((props) => {
    var _a, _b;
    const field = useField();
    const prefixCls = usePrefixCls('form-text', props);
    const dataSource = ((_a = field === null || field === void 0 ? void 0 : field.dataSource) === null || _a === void 0 ? void 0 : _a.length)
        ? field.dataSource
        : ((_b = props === null || props === void 0 ? void 0 : props.options) === null || _b === void 0 ? void 0 : _b.length)
            ? props.options
            : [];
    const placeholder = usePlaceholder();
    const getSelected = () => {
        return props.value || [];
    };
    const getLabel = (target) => {
        var _a;
        return (((_a = dataSource === null || dataSource === void 0 ? void 0 : dataSource.find((item) => item.value == target)) === null || _a === void 0 ? void 0 : _a.label) || placeholder);
    };
    const getLabels = () => {
        const selected = getSelected();
        if (!selected.length)
            return placeholder;
        if (selected.length === 1)
            return getLabel(selected[0]);
        return selected.map((item, key) => {
            return (React.createElement(Tag, { key: key, fill: "outline" }, getLabel(item)));
        });
    };
    return (React.createElement("div", { className: cls(prefixCls, props.className), style: props.style }, getLabels()));
});
const DatePicker = (props) => {
    const placeholder = usePlaceholder();
    const prefixCls = usePrefixCls('form-text', props);
    const getLabels = () => {
        const labels = formatMomentValue(props.value, props.format, placeholder);
        return isArr(labels) ? labels.join('~') : labels;
    };
    return React.createElement("div", { className: cls(prefixCls, props.className) }, getLabels());
};
const Cascader = observer((props) => {
    var _a, _b;
    const field = useField();
    const placeholder = usePlaceholder();
    const prefixCls = usePrefixCls('form-text', props);
    const dataSource = ((_a = field === null || field === void 0 ? void 0 : field.dataSource) === null || _a === void 0 ? void 0 : _a.length)
        ? field.dataSource
        : ((_b = props === null || props === void 0 ? void 0 : props.options) === null || _b === void 0 ? void 0 : _b.length)
            ? props.options
            : [];
    const getSelected = () => {
        return isArr(props.value) ? props.value : [];
    };
    const findLabel = (value, dataSource) => {
        for (let i = 0; i < (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length); i++) {
            const item = dataSource[i];
            if ((item === null || item === void 0 ? void 0 : item.value) === value) {
                return item === null || item === void 0 ? void 0 : item.label;
            }
            else {
                const childLabel = findLabel(value, item === null || item === void 0 ? void 0 : item.children);
                if (childLabel)
                    return childLabel;
            }
        }
    };
    const getLabels = () => {
        const selected = getSelected();
        if (!(selected === null || selected === void 0 ? void 0 : selected.length)) {
            return placeholder;
        }
        const labels = selected.map((value) => {
            return findLabel(value, dataSource) || placeholder;
        });
        if (isFn(props.renderText)) {
            return props.renderText(labels);
        }
        return labels.join(' / ');
    };
    return (React.createElement("div", { className: cls(prefixCls, props.className), style: props.style }, getLabels()));
});
Text.Input = Input;
Text.Selector = Selector;
Text.Placeholder = Placeholder;
Text.DatePicker = DatePicker;
Text.Cascader = Cascader;
Text.usePlaceholder = usePlaceholder;
export const PreviewText = Text;
export default PreviewText;
//# sourceMappingURL=index.js.map